import React from "react";
import "./Services.css";

export default function Services() {
  const services = [
    {
      number: "01",
      icon: "⚡",
      title: "Sports Exchange Development",
      description:
        "360 Gaming Labs builds ultra-secure, lightning-fast sports exchange platforms with real-time liquidity, instant order matching, risk-free trading, and automated price balancing. Deliver an unmatched trading experience with high scalability, multi-market depth, and advanced analytics.",
    },
    {
      number: "02",
      icon: "🧰",
      title: "White Label iGaming Solutions",
      description:
        "Launch your brand instantly with our fully managed White Label iGaming Suite. Get everything from sportsbook, casino, payments, AML/KYC, CRM, and brand customization—ready to go live in just 1 to 2 weeks accordingly. Perfect for entrepreneurs, start-ups, and enterprise-level gaming operators.",
    },
    {
      number: "03",
      icon: "🎯",
      title: "Sportsbook & Betting Solutions",
      description:
        "Our world-class Sportsbook Engine powers pre-match, live betting, multi-sport coverage, and dynamic odds feed. 360 Gaming Labs ensures flawless risk management, global sports coverage, modular architecture, and a UI designed to maximize engagement, retention and revenue.",
    },
    {
      number: "04",
      icon: "🎰",
      title: "Casino Game Development",
      description:
        "360 Gaming Labs builds immersive Slots, Table Games, Live Dealers, Crash Games, Sweepstakes, and more with Advanced RNG certification, Cross-platform compatibility, Stunning visuals & animations, High-performance game mechanics. Stay competitive with highly impactful & powerful solutions.",
    },
    {
      number: "05",
      icon: "🎮",
      title: "Custom Game Development",
      description:
        "Your vision - our engineering excellence. We develop unique, original, and highly engaging iGaming games, including Custom slot titles, Multiplayer & P2P games, High-volatility crash games, Gamified Web3 experiences, built with unbeatable security, creativity, and stability for Next Gen Solutions.",
    },
    {
      number: "06",
      icon: "🛡️",
      title: "Cyber Security for iGaming",
      description:
        "360 Gaming Labs delivers multi-layered cyber protection with AI fraud detection, anti-DDoS, WAF, encryption, and 24/7 monitoring. We secure transactions, user data, and gameplay integrity—ensuring a safe, compliant, and uninterrupted iGaming experience for all the game operators.",
    },
  ];

  return (
    <section id="services" className="services-section">
      <div className="container">
        <div className="section-header">
          <div className="section-badge">Our Services</div>
          <h2 className="section-title">
            The Ultimate 360° End-to-End<br />
            <span className="gradient-text">iGaming Services</span>
          </h2>
          <p className="section-subtitle">
            Powered by 360 Gaming Labs
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, i) => (
            <div key={i} className="service-card" data-index={i}>
              <div className="card-number-circle">{service.number}</div>
              <div className="card-content-wrapper">
                <div className="card-icon">{service.icon}</div>
                <h3 className="card-title">{service.title}</h3>
                <p className="card-description">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
